export const isEven = (number: number | string) => {
    if (typeof number === 'string') {
        number = Number(number)
    }
    return (number % 2 == 0)
}